var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m246.666667 46.52v1.6h2.333333l-.291667 2.88h-2.041666v8h-3.208334v-8h-1.458333v-2.88h1.458333v-1.6s-.2625-3.04 2.333334-3.52h3.208333v2.56h-1.458333s-.816667-.032-.875.96","fill":"#002d58","fillRule":"evenodd","transform":"translate(-242 -43)"}));
}

FacebookIcon.defaultProps = {"height":"16","viewBox":"0 0 7 16","width":"7"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
